import { getYear } from 'date-fns';
import { option } from './types';

export const getAllDays = (): option[] => {
	const list: option[] = [];
	for (let i = 0; i < 31; i++) {
		list.push({
			value: '' + (i + 1),
			label: '' + (i + 1),
		});
	}
	return list;
};

export const getAllMonths = (): option[] => {
	const list: option[] = [];
	for (let i = 0; i < 12; i++) {
		list.push({
			value: '' + i,
			label: '' + (i + 1),
		});
	}
	return list;
};

export const getYears = (yearsAgo = 18): option[] => {
	const list: option[] = [];
	const thisYear = getYear(new Date());
	for (let i = 0; i < 100; i++) {
		list.push({
			value: '' + (thisYear - yearsAgo - i),
			label: '' + (thisYear - yearsAgo - i),
		});
	}
	return list;
};

export const formatNumber = (val?: string | number) => {
	const parsed = Number(String(val).replace(/,/g, ''));

	if (Number.isNaN(parsed) || val === '') {
		return val;
	}

	return parsed.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

const AMOUNT_DECIMAL_LIMIT = 2;

export const getRawAmountInputValue = (value?: string | number | boolean | null | Record<string, any>) => {
	if (value == null) return '';

	const [integer, ...decimals] = String(value).replace(/[^\d.]/g, '').split('.');

	return decimals.length ? `${integer}.${decimals.join('').slice(0, AMOUNT_DECIMAL_LIMIT)}` : integer;
};

export const getFormattedAmountInputDisplayValue = (value?: string | number | boolean | null | Record<string, any>) => {
	const rawValue = getRawAmountInputValue(value);

	if (!rawValue) return '';

	const [integer, decimal] = rawValue.split('.');
	const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

	return rawValue.includes('.') ? `${formattedInteger}.${decimal ?? ''}` : formattedInteger;
};
